import React, { useEffect, useRef } from 'react';

// Premium ambient backdrop — replaces the old Three.js star field with
// something far more restrained: a subtle radial wash, a faint grid that
// fades at the edges, two slowly drifting orbs, and a cursor-aware glow.
// All CSS / pointer events — no GPU-thirsty 3D scene.
export default function AmbientBackground() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      el.style.setProperty('--cx', x + '%');
      el.style.setProperty('--cy', y + '%');
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <div className="ambient" ref={ref} aria-hidden="true">
      <div className="ambient__orb ambient__orb--a" />
      <div className="ambient__orb ambient__orb--b" />
      <div
        className="ambient__cursor"
        style={{
          position: 'absolute',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,193,7,0.06), transparent 60%)',
          left: 'var(--cx, 50%)',
          top: 'var(--cy, 50%)',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          transition: 'left .6s cubic-bezier(.16,.84,.44,1), top .6s cubic-bezier(.16,.84,.44,1)',
          mixBlendMode: 'plus-lighter',
        }}
      />
      <div className="ambient__grid" />
      <div className="ambient__noise" />
    </div>
  );
}
